module.exports = __webpack_public_path__ + "static/img/22.a515438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/22.png
// module id = W/+w
// module chunks = 10